import { ChevronLeft, ChevronRight, Loader2 } from 'lucide-react';
import { Button } from '../core/Button';
import { useWizard } from '../../context/WizardContext';

interface NavigationButtonsProps {
  onNext?: () => void;
  nextLabel?: string;
  isLoading?: boolean;
}

export function NavigationButtons({
  onNext,
  nextLabel = 'Continue',
  isLoading = false,
}: Readonly<NavigationButtonsProps>) {
  const { currentStepIndex, totalSteps, goPrev, goNext, canGoNext } = useWizard();

  const isFirst = currentStepIndex === 0;
  const isLast = currentStepIndex === totalSteps - 1;

  function handleNext() {
    if (onNext) {
      onNext();
    } else {
      goNext();
    }
  }

  return (
    <div className="flex items-center justify-between pt-6 border-t border-slate-700 mt-2">
      <div>
        {!isFirst && (
          <Button variant="outline" onClick={goPrev} disabled={isLoading} size="default">
            <ChevronLeft className="h-4 w-4" />
            Previous
          </Button>
        )}
      </div>
      <div>
        {!isLast && (
          <Button onClick={handleNext} disabled={!canGoNext || isLoading} size="default">
            {isLoading ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" />
                Loading…
              </>
            ) : (
              <>
                {nextLabel}
                <ChevronRight className="h-4 w-4" />
              </>
            )}
          </Button>
        )}
      </div>
    </div>
  );
}
